import React, { useState } from 'react';
import { Carousel } from "react-responsive-carousel"
import CardEvent from "../../v2023/UI/Card/card-event"
import CardPost from "../../v2023/UI/Card/card-post"
import { WhiteTileOpinion } from "../tile/tile"

const normalizeSlidesCardPost = (slides) => slides.map(normalizeSlideCardPost)

const normalizeSlideCardPost = (slide) => ({
    title: slide.node?.name || slide.node?.title || slide.title,
    message: slide.node?.seo?.meta_description || slide.node?.description || slide.description,
    image: slide.node?.thumbnail_2 || slide.node?.seo?.image_2 || slide.node?.image || slide.image,
    url: slide.node?.url || slide.case_study?.url
})

const normalizeSlidesTestimonial = (slides) => slides.map(normalizeSlideTestimonial)

const normalizeSlideTestimonial = (slide) => ({
    message: slide.node?.message || slide.node?.description || slide.opinion?.message,
    image: slide.node?.company_logo_2 || slide.node?.media?.media || slide.opinion?.company_logo_2,
    avatar: {
        name: slide.node?.name || slide.opinion?.name,
        department: slide.node?.job_position || slide.opinion?.job_position
    }
})

export const CarouselTouch = ({
    slides,
    lang,
    showArrows = false,
    showStatus = false,
    showThumbs = false,
    showIndicators = false,
    hideShowMore = false,
    useCardPost = false,
    useCardEvent = false,
    useTestimonial = false,
    useCustomCarousel = false, // Nueva prop para layout personalizado
    useShowLinkedIn = false,
    useShowMore2 = false,
    size = null,
}) => {
    const [carouselIndicator, setCarouselIndicator] = useState(0)

    const nextCarousel = () => {
        if (carouselIndicator === slides.length - 1) {
            setCarouselIndicator(0)
            return
        }
        setCarouselIndicator(carouselIndicator + 1)
    }

    const prevCarousel = () => {
        if (carouselIndicator === 0) {
            setCarouselIndicator(slides.length - 1)
            return
        }
        setCarouselIndicator(carouselIndicator - 1)
    }


    return (
        <div className="carrousel carrousel--touch">
            <div className="carrousel__content">
                {/* Flecha izquierda */}
                {showArrows && (
                    <div className="carrousel__content__button carrousel__content__button--prev">
                        <button className="button-icon button-icon--secondary button-icon--lg" onClick={prevCarousel}>
                            <i className="icon-arrow-left"></i>
                        </button>
                    </div>
                )}
                {/* Contenedor del Carousel */}
                <div className="carrousel__content__box">
                    <Carousel
                        showArrows={false}
                        showStatus={false}
                        showThumbs={false}
                        showIndicators={false}
                        selectedItem={carouselIndicator}
                        onChange={(index) => setCarouselIndicator(index)}
                    >
                        {generateCarouselContent(
                            slides,
                            carouselIndicator,
                            useCardPost,
                            useCardEvent,
                            useTestimonial,
                            hideShowMore,
                            lang,
                            useCustomCarousel, // Pasamos la nueva prop
                            useShowMore2,
                            useShowLinkedIn,
                            size
                        )}
                    </Carousel>
                </div>
                {/* Flecha derecha */}
                {showArrows && (
                    <div className="carrousel__content__button carrousel__content__button--next">
                        <button className="button-icon button-icon--secondary button-icon--lg" onClick={nextCarousel}>
                            <i className="icon-arrow-right"></i>
                        </button>
                    </div>
                )}
            </div>
            {/* Indicadores */}
            {showIndicators && (
                <div className="carrousel__dots">
                    {slides.map((item, index) => (
                        <div
                            className={`dots__dot ${carouselIndicator === index ? "dots__dot--active" : ""}`}
                            key={index}
                            onClick={() => setCarouselIndicator(index)}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}

const generateCarouselContent = (
    slides,
    selectedIndex,
    useCardPost,
    useCardEvent,
    useTestimonial,
    hideShowMore,
    lang,
    useCustomCarousel,
    useShowMore2,
    useShowLinkedIn,
    size
) => {
    if (useCardPost) {
        const normalizedSlides = normalizeSlidesCardPost(slides)
        return normalizedSlides.map((slide, index) => {
            const showMore = slide.url && !hideShowMore ? true : false
            const showMore2 = useShowMore2 && slide.url && !hideShowMore
            const showLinkedIn = useShowLinkedIn && slide.url && hideShowMore && !useShowMore2

            return (
                <CardPost
                    key={index}
                    name={slide.title}
                    description={slide.message}
                    image={slide.image}
                    url={slide.url}
                    showMore={showMore}
                    showMore2={showMore2}
                    showLinkedIn={showLinkedIn}
                    lang={lang}
                    horizontal
                    big
                    size={size}
                />
            )
        })
    } else if (useCardEvent) {
        return slides.map((slide, index) => (
            <CardEvent key={index} lang={lang} event={slide.node} showDescription={true} horizontal={true} principal />
        ))
    } else if (useTestimonial) {
        const normalizedSlides = normalizeSlidesTestimonial(slides)
        return normalizedSlides.map((slide, index) => (
            <WhiteTileOpinion key={index} opinion={slide.message} avatar={slide.avatar} logo={slide.image} />
        ))
    } else {
        // Por defecto, se utiliza un layout similar a WhiteTileOpinion
        return slides.map((slide, index) => (
            <WhiteTileOpinion key={index} opinion={slide.message} logo={slide.image} url={slide.url} urlText={slide.knowMore} />
        ))
    }
}

export default CarouselTouch
